// Nativos
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FidelidadeService } from '../../_services/fidelidade.service';
import * as alerts from '../../_functions/alerts';

@Component({
  selector: 'app-esqueci-senha',
  templateUrl: './esqueci-senha.component.html',
  styleUrls: ['./esqueci-senha.component.scss'],
})
export class EsqueciSenhaComponent {
  cpf: string = '';
  exibeErro: boolean = false;

  constructor(
    private fidelidadeService: FidelidadeService,
    private router: Router
  ) {}

  enviarEmail() {
    this.exibeErro = false;

    if (!this.cpf) {
      this.exibeErro = true;
      return;
    }

    this.fidelidadeService.enviarEmailEsqueciSenhaMembro(this.cpf).subscribe(
      (sucesso) => {
        this.processarSucesso(sucesso);
      },
      (falha) => {
        this.processarFalha(falha);
      }
    );
  }

  processarSucesso(response: any) {
    let emailTruncate = '';

    var email = response.email.split('@');

    if (response.email) emailTruncate = email[0].substring(0, 4) + '...@' + email[1].substring(0, 5);

    this.router.navigate(['/']);

    alerts.exibirSwal(
      'success',
      'Obaaa 😍',
      `<div class="text-left">
                Foi enviado o e-mail para <strong>${emailTruncate}...</strong>

                contendo as informações.
                <br>
                Cheque sua caixa de entrada para redefinir.
             </div>`,
      'center',
      6000
    );
  }

  processarFalha(fail: any) {
    if (fail == 'Cpf não cadastrado em nossa base de dados!') {
      alerts.exibirSwal(
        'info',
        'Poxaaa 😥',
        `<div class="text-left"> Seu CPF não foi encontrado em nossa base. </div>`
      );

      return;
    }

    alerts.exibirSwal(
      'error',
      'Atenção',
      `<div class="text-left"> ${fail} </div>`
    );
  }

  voltarParaHome(): void {
    this.router.navigate(['/']);
  }
}
